import { useMemo } from 'react';
import { RemoteRequestModal } from './components/remoteRequestModal';
import { useUpdateGreetingSound } from './hooks/useUpdateGreetingSound';
import { ReadyModeSvg } from './components/ReadyModeSvg';
import { ManualModeSvg } from './components/ManualModeSvg';
import { useIsDriver } from '../../../../hooks/useIsDriver';
import { useSendUserInput } from '../../../../provider/socketContext';
import {
	useDisplayStore,
	useModeStore,
	useWelcomeStore,
} from '../../../../store/sceneStore';
export function AutonomousModeWidget() {
	const { data: display, setState: setDisplay } = useDisplayStore((s) => s);
	const { data: welcome, setState: setWelcome } = useWelcomeStore((s) => s);

	const mode = useModeStore();

	const onUpdateGreetingSound = useUpdateGreetingSound();
	const sendUserInput = useSendUserInput();

	const onClickCancel = () => {
		const msg = {
			type: 'user_input',
			text: 'ready_button',
			value: 1,
		};
		sendUserInput(msg);
	};

	const onClickLogo = () => {
		if (mode.ready) {
			// ready -> start
			const msg = {
				type: 'user_input',
				text: 'run_button',
				value: 1,
			};
			sendUserInput(msg);
		} else {
			// manual -> ready
			const msg = {
				type: 'user_input',
				text: 'ready_button',
				value: 1,
			};
			sendUserInput(msg);
		}
	};

	const onClickDisplayHide = () => {
		setDisplay({ ...display, mode: false });
	};

	const onClickIntroductionMessage = () => {
		setWelcome({ ...welcome, introduction: !welcome.introduction });
	};

	const onClickGreetingMessage = () => {
		onUpdateGreetingSound();
	};

	const onClickDisplayShow = () => {
		setDisplay({ ...display, mode: true });
	};

	const CI_status = useMemo(
		() => mode.ready && !mode.run,
		[mode.ready, mode.run],
	);
	const isDisabledCancelButton = useMemo(
		() => !(mode.ready || mode.pause),
		[mode.ready, mode.pause],
	);
	const modeIcon = useMemo(
		() => (CI_status ? <ReadyModeSvg /> : <ManualModeSvg />),
		[CI_status],
	);

	return (
		<>
			<div
				className={`displaybutton ${display.mode || (mode.ready && mode.run) ? '' : 'Show'}`}
			>
				<button
					type='button'
					className='Button'
					style={{ backgroundColor: 'rgba(0,0,0,0)' }}
					onClick={onClickDisplayShow}
					disabled={false}
				>
					<i className='mdi mdi-36px mdi-car-connected'></i>
					<br></br>
				</button>
			</div>
			<button
				type='button'
				className='Button'
				style={{ backgroundColor: 'rgba(0,0,0,0)' }}
				onClick={onClickDisplayHide}
				disabled={false}
			>
				<i className='mdi mdi-36px mdi-flip-v mdi-exit-to-app'></i>
				<br></br>
			</button>
			<button
				type='button'
				className='Button'
				style={{ backgroundColor: 'rgba(0,0,0,0)' }}
				onClick={onClickIntroductionMessage}
				disabled={false}
			>
				<i
					style={{
						color: welcome.introduction
							? 'rgba(255,255,255,1.0)'
							: 'rgba(255,255,255,0.2)',
					}}
					className='mdi mdi-36px mdi-information-outline'
				></i>
				<br></br>
			</button>
			<button
				type='button'
				className='Button'
				style={{ backgroundColor: 'rgba(0,0,0,0)' }}
				onClick={onClickGreetingMessage}
				disabled={false}
			>
				<i
					style={{
						color: welcome.greeting
							? 'rgba(255,255,255,1.0)'
							: 'rgba(255,255,255,0.2)',
					}}
					className='mdi mdi-36px mdi-human-greeting'
				></i>
				<br></br>
			</button>
			<div className='ad-button'>
				<button onClick={onClickLogo}>{modeIcon}</button>
				<button
					type='button'
					className='Button'
					style={{
						marginTop: '1em',
						color: `${!isDisabledCancelButton ? '#fff' : 'rgba(0,0,0,0)'}`,
						backgroundColor: 'rgba(0,0,0,0)',
						transition: 'all 0.5s ease-in-out',
					}}
					onClick={onClickCancel}
					disabled={isDisabledCancelButton}
				>
					<i className='mdi mdi-36px mdi-close-circle'></i>
					<br></br>
				</button>
			</div>

			<RemoteRequestModal />
		</>
	);
}
